import * as React from "react"

const DirectRoute = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 361.24 115.1" {...props}>
    <title>{"about-direct-route-3"}</title>
    <path
      fill="#4ead90"
      d="m361.24 0-26.92 9.83L307.41 0l26.91 37.25L361.24 0z"
    />
    <path fill="#b9d816" d="m361.24 0-26.92 9.83L307.41 0h53.83z" />
    <path fill="#317d6e" d="M334.32 37.25 361.24 0l-26.92 9.83v27.42z" />
    <path
      d="M0 64.24A20.72 20.72 0 1 1 20.72 85 20.72 20.72 0 0 1 0 64.24Zm312.15 0A20.72 20.72 0 1 1 332.86 85a20.72 20.72 0 0 1-20.71-20.76Zm21-15.63a15.63 15.63 0 1 1-15.64 15.63 15.63 15.63 0 0 1 15.64-15.63ZM5.08 64.24a15.64 15.64 0 1 1 15.65 15.63A15.65 15.65 0 0 1 5.08 64.24Z"
      fill="#317d6e"
      fillRule="evenodd"
    />
    <path
      d="M254.83 112.18c-28.63 0-57.23-13.85-84.85-41.46-43.8-43.81-86.42-47.53-130.3-11.39L27.6 44.67C79 2.35 132.85 6.71 183.42 57.28c43.85 43.85 86.5 47.57 130.39 11.39l12.08 14.66c-23.34 19.25-47.22 28.85-71.06 28.85Z"
      fill="#317d6e"
    />
    <path
      d="M97.77 36a10.32 10.32 0 1 1 10.31-10.33A10.34 10.34 0 0 1 97.77 36Z"
      fill="#fff"
    />
    <path
      d="M97.77 17.35a8.32 8.32 0 1 1-8.32 8.32 8.32 8.32 0 0 1 8.32-8.31m0-4a12.32 12.32 0 1 0 12.31 12.33 12.33 12.33 0 0 0-12.31-12.34Z"
      fill="#317d6e"
    />
    <path
      d="M256.28 113.09a10.32 10.32 0 1 1 10.32-10.32 10.32 10.32 0 0 1-10.32 10.32Z"
      fill="#fff"
    />
    <path
      d="M256.28 94.46a8.32 8.32 0 1 1-8.32 8.32 8.32 8.32 0 0 1 8.32-8.31m0-4a12.32 12.32 0 1 0 12.32 12.32 12.33 12.33 0 0 0-12.32-12.33Z"
      fill="#317d6e"
    />
    <path fill="#b9d816" d="M30.04 58.31h294.41v12H30.04z" />
    <path
      d="M32 64.24A11.27 11.27 0 1 0 20.72 75.5 11.28 11.28 0 0 0 32 64.24Zm-19.86 0a8.6 8.6 0 1 1 8.6 8.6 8.6 8.6 0 0 1-8.62-8.6Zm2.15 0a6.45 6.45 0 1 1 6.45 6.45 6.45 6.45 0 0 1-6.47-6.43ZM333.17 75.5a11.26 11.26 0 1 0-11.26-11.26 11.26 11.26 0 0 0 11.26 11.26Zm0-19.86a8.6 8.6 0 1 1-8.6 8.6 8.6 8.6 0 0 1 8.6-8.6Zm0 2.15a6.45 6.45 0 1 1-6.45 6.45 6.45 6.45 0 0 1 6.45-6.45Z"
      fill="#b9d816"
      fillRule="evenodd"
    />
  </svg>
)

export default DirectRoute
